import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import auditLogDetailsListApi from '../../../../middleware/api/Invoicing/Invoices/InvoicesAuditLog/invoicesAuditLogListApi'
import { LoadingState, ValidationError } from '../../../../types/commonTypes'
import { ApiLoadingState } from '../../../../middleware/api/apiList'
import {
  AuditDateProps,
  AuditLogDetailsListState,
  GetAuditLogDetailsType,
} from '../../../../types/Invoicing/InvoiceAuditLog/invoiceAuditLogtype'
import { RootState } from '../../../../stateStore'

const getInvoiceAuditLogList = createAsyncThunk(
  'invoicing/getInvoiceAuditLogList',
  async (props: AuditDateProps, thunkApi) => {
    try {
      return await auditLogDetailsListApi.getInvoiceAuditLogList(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const curMonth = 'Today'

export const initialAuditLogState: AuditLogDetailsListState = {
  getAuditLogList: {} as GetAuditLogDetailsType,
  auditlogListValue: curMonth,
  isLoading: ApiLoadingState.idle,
  listSize: 0,
}
const invoiceAuditLogDetailsSlice = createSlice({
  name: 'invoicingAuditLog',
  initialState: initialAuditLogState,
  reducers: {
    setMonthValue: (state, action) => {
      state.auditlogListValue = action.payload
    },
    clearAuditLogList: (state) => {
      state.auditlogListValue = ''
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInvoiceAuditLogList.fulfilled, (state, action) => {
      state.getAuditLogList = action.payload
      state.isLoading = ApiLoadingState.succeeded
    })
    builder.addCase(getInvoiceAuditLogList.pending, (state) => {
      state.isLoading = ApiLoadingState.loading
    })
  },
})
const invoiceAuditLogThunk = {
  getInvoiceAuditLogList,
}
const isLoading = (state: RootState): LoadingState =>
  state.invoiceAuditLog.isLoading

const invoiceLog = (state: RootState): GetAuditLogDetailsType =>
  state.invoiceAuditLog.getAuditLogList
const listSize = (state: RootState): number => state.invoiceAuditLog.listSize

const invoiceAuditLogSelectors = {
  isLoading,
  invoiceLog,
  listSize,
}
export const invoiceAuditLogService = {
  ...invoiceAuditLogThunk,
  actions: invoiceAuditLogDetailsSlice.actions,
  selectors: invoiceAuditLogSelectors,
}
export default invoiceAuditLogDetailsSlice.reducer
